import { Component } from '../base-component';
import './spinner.scss';

export class Spinner extends Component {
  constructor(size) {
    super(`<div class="spinner ${size || 'medium'}"></div>`);
  }
}
